/*
 * report-job (schema)
 */
import { boolean, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const reportJobs = schema.table("report_jobs", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	userId: uuid("user_id").references(() => users.id, { onDelete: "set null" }),

	// --- Report ---
	reportType: varchar("report_type", { length: 64 }).notNull(), // "client_master"
	status: varchar("status", { length: 32 }).notNull().default("pending"), // pending | processing | complete | error
	filters: text("filters"), // JSON string
	rowCount: integer("row_count"),
	s3Key: varchar("s3_key", { length: 512 }),
	errorMessage: text("error_message"),
	completedAt: timestamp("completed_at", { withTimezone: true }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
